module.exports = __webpack_public_path__ + "static/img/100075.cff62bc6.png";